import { UpdateDepositValues, VehicleConditionOptions, VehicleType } from 'types';
import { boolean, number, object, ObjectSchema, string } from 'yup';

const schemaBase = object().shape<Partial<UpdateDepositValues>>({
  firstHand: boolean().required('Ce champ est obligatoire.'),
  imported: boolean().required('Ce champ est obligatoire.'),
  mileage: number().required('Ce champ est obligatoire.').positive('Le nombre doit être positif').integer(),
  condition: string().oneOf(VehicleConditionOptions).required('Ce champ est obligatoire.'),
  externalColor: string().required('Ce champ est obligatoire.'),
  paintType: string().required('Ce champ est obligatoire.'),
  vehiclePrice: number().required('Ce champ est obligatoire.').positive('Le nombre doit être positif').integer(),
});

const schemaAuto = schemaBase.concat(
  object().shape({
    internalColor: string().required('Ce champ est obligatoire.'),
    seatMaterial: string().required('Ce champ est obligatoire.'),
  }),
);

export const updateVehicleValidationSchema: Record<VehicleType, ObjectSchema> = {
  AUTO: schemaAuto,
  MOTO: schemaBase,
  UTILITAIRE: schemaAuto,
  CARAVANE: schemaAuto,
  'CAMPING-CAR': schemaAuto,
  UNKNOWN: object(),
};
